import { useParams } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { MediaPanel } from '@/components/MediaPicker';

/**
 * `/server/:guildId/media` — full-page media library.
 * Same panel as the popover-picker, just embedded in the page frame.
 */
export function MediaLibrary() {
  const { guildId } = useParams<{ guildId: string }>();
  if (!guildId) return null;
  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="mb-2 text-2xl font-semibold">Media-Bibliothek</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Alle hochgeladenen Bilder für diesen Server. Sie sind nur für Mitglieder
        dieses Servers erreichbar und werden in Embeds / Welcome-Banner /
        Panels wiederverwendet.
      </p>
      <Card className="p-0">
        <MediaPanel guildId={guildId} />
      </Card>
    </div>
  );
}
